import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'react-modal'
import Select from 'react-select'
import AnimationLayout from '../components/AnimationLayout'
import Button from '../components/Button'
import MatildeBalloon from '../components/MatildeBalloon'

function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

const Achievements = () => {
    const allLockedAchievements = useSelector(state => state.apiCalls.apiData.lockedAchievs)
    const user = useSelector(state => state.apiCalls.apiData.user)
    const loggedUser = useSelector(state => state.firebase.profile)
    const isLoggedInUserProfile = user?.username ? false : true
    const userObject = user?.username ? user : loggedUser
    const { achievements } = userObject
    const unmutableAchievs = achievements

    const [state, setState] = useState({
        filterType: '',
        filterMethod: '',
        unmutableAchievs: unmutableAchievs,
        achievs: [...achievements],
        showAllAchievs: false,
        open: false,
        item: null
    })

    const { achievs, showAllAchievs, item, open } = state
    let portionLockedAchievements = []

    if (allLockedAchievements.length === 0) {
        portionLockedAchievements = 'no locked achievements'
    } else {
        const counter = allLockedAchievements.length > 3 ? 3 : allLockedAchievements.length
        for (let i = 0; i < counter; i++) {
            portionLockedAchievements.push(allLockedAchievements[i])
        }
        portionLockedAchievements.sort((a, b) => a > b)
    }

    const achievsPortion = achievs.length !== 0 ? achievs.slice(0, 10) : null
    const remainingAchievs = achievs.length !== 0 ? achievs.slice(10, achievs.length) : null

    const updateInput = (ev, { action }) => {
        if (action === 'clear') {
            setState({ ...state, filterType: null, achievs: [...unmutableAchievs], showAllAchievs: false })
        } else {
            const { value } = ev
            setState({ ...state, filterType: value })
        }
    }


    const updateFilterMethod = (ev, { action }) => {
        if (action === 'clear') {
            setState({ ...state, filterMethod: null, achievs: [...unmutableAchievs], showAllAchievs: false })
        } else {
            const { value, label } = ev
            const { filterType } = state
            let returnAchievs

            if (value === 'ascendent') {
                returnAchievs = state.achievs.sort((a, b) => a.name > b.name);
            } else if (value === 'descendent') {
                returnAchievs = state.achievs.sort((a, b) => a.name < b.name);
            } else if (filterType === 'rarity') {
                returnAchievs = state.achievs.filter(item => item.rarity.toLowerCase() === value)
            }

            setState({ ...state, achievs: returnAchievs, filterMethod: { value, label }, showAllAchievs: false })
        }
    }

    const typeOptions = [
        { value: 'name', label: 'Nome' },
        { value: 'rarity', label: 'Raridade' },
    ]

    const methodOptions = state.filterType !== 'rarity' ?
        [
            { value: 'ascendent', label: 'Ascendente' },
            { value: 'descendent', label: 'Descendente' }
        ]
        :
        [
            { value: 'muito rara', label: 'Muito rara' },
            { value: 'rara', label: 'Rara' },
            { value: 'comum', label: 'Comum' },
        ]

    const printAchievies = (item, index) => {
        return (
            <Button
                key={index}
                onClick={() => setState({ ...state, open: !state.open, item: item })}
                className="image-button usable mr-0 p-4 flex flex-col justify-center"
            >
                <img
                    className='mx-auto pb-2'
                    alt={item.name}
                    title={item.name}
                    src={require(`../assets/img/achievements/${item.img}.png`)}
                />
                <h3 className='pb-2'>{item.name}</h3>
                <p className='pb-2 italic'>{item.rarity}</p>
            </Button>
        )
    }

    console.log(state)

    return (
        <AnimationLayout>
            <h1 className='full-width'>Proezas</h1>
            <div id="achievements">
                <div>
                    {isLoggedInUserProfile &&
                        <MatildeBalloon>
                            <h3 className='p-0'>Está agora na página das proezas</h3>
                            <p>Aqui poderá observar as proezas que foi conquistando ao longo do jogo, podendo descobrir o nível de raridade das mesmas o tipo de requrimento para serem desbloqueadas</p>
                        </MatildeBalloon>
                    }
                    {achievements.length > 0 &&
                        <div className='white-container py-4'>
                            <p className='pb-2'>Filtre ordem das proezas por:</p>
                            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-0 lg:gap-8'>
                                <Select
                                    options={typeOptions}
                                    isClearable={true}
                                    isSearchable={false}
                                    placeholder='Selecione a forma de filtrar'
                                    className='block appearance-none shadow appearance-none rounded w-full my-3'
                                    onChange={updateInput}
                                    classNamePrefix='react-select'
                                    aria-label='Menu de formas de filtragem para proezas'
                                    aria-labelledby='Formas de filtragem para proezas'
                                />

                                <Select
                                    isDisabled={!state.filterType ? true : false}
                                    options={methodOptions}
                                    isClearable={true}
                                    isSearchable={false}
                                    placeholder='Selecione o método de filtragem'
                                    className='block appearance-none shadow appearance-none rounded w-full my-3'
                                    onChange={updateFilterMethod}
                                    classNamePrefix='react-select'
                                    aria-label='Menu de métodos de filtragem para proezas'
                                    aria-labelledby='Método de filtragem para proezas'
                                />
                            </div>
                        </div>
                    }
                    <article className='w-full mb-10'>
                        <h3 className='pb-6'>Proezas Desbloqueadas</h3>
                        {userObject.achievements.length === 0 ?
                            isLoggedInUserProfile ?
                                <>
                                    <h4>Ainda não conquistou qualquer tipo de proeza!</h4>
                                    <p>Para conquistar novas proezas experimente as diferentes narrativas da Matilde ou então jogue algumas partidas do Mundo em Notícias</p>
                                </>
                                :
                                <p>Este utilizador não conquistou qualquer tipo de proeza!</p>
                            :
                            <>
                                <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 lg:gap-12'>
                                    {userObject.achievements.length && achievsPortion === null ?
                                        isLoggedInUserProfile ?
                                            <p>Não tem qualquer tipo de proeza com a raridade - {state.filterMethod.label}</p>
                                            :
                                            <p>Este utilizador não tem qualquer de proeza com a raridade - {state.filterMethod.label}</p>
                                        :
                                        achievsPortion && achievsPortion.map((item, index) => printAchievies(item, index))
                                    }
                                    {showAllAchievs &&
                                        remainingAchievs.map((item, index) => printAchievies(item, index))
                                    }
                                </div>
                                {achievsPortion && achievsPortion.length > 10 &&
                                    <div className='flex justify-end mt-10'>
                                        <Button className='mr-0' onClick={() => setState({ ...state, showAllAchievs: true })}>
                                            Ver todas
                                        </Button>
                                    </div>
                                }
                            </>
                        }
                    </article>
                    <div className="w-full mb-10">
                        <h3 className='pb-6'>Proezas Bloqueadas</h3>
                        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 lg:gap-12'>
                            {typeof portionLockedAchievements !== 'object' ?
                                <>
                                    <h4>Parabéns!</h4>
                                    <p>Desbloqueou todas proezas que há para conquistar! É um verdadeiro aventureiro que sabe se informar e cuidar-se!</p>
                                </>
                                :
                                <>
                                    {portionLockedAchievements.map((item, index) =>
                                        <div
                                            key={index}
                                            className="image-button disabled mr-0 p-4 flex flex-col justify-center"
                                        >
                                            <img
                                                className='mx-auto opacity-50'
                                                alt={item.name}
                                                title={item.name}
                                                src={require(`../assets/img/achievements/${item.img}.png`)}
                                            />
                                            <p className='mt-4 pb-2'>{item.name}</p>
                                        </div>
                                    )}
                                    {allLockedAchievements.length > 3 &&
                                        <div className="image-button disabled mr-0 p-4 flex flex-col justify-center">
                                            <h4 className='pb-2'>+{allLockedAchievements.length - portionLockedAchievements.length - 3}</h4>
                                            <p>Proezas restantes para desbloquear</p>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>

            </div>

            {item &&
                <Modal
                    isOpen={open}
                    contentLabel="Modal de item individual"
                    className='modal'
                    ariaHideApp={false}
                    closeTimeoutMS={300}
                    shouldCloseOnOverlayClick={true}
                >
                    <div className='modal-guts'>
                        <div className='flex flex-wrap justify-between items-center'>
                            <h2>{item.name}</h2>
                        </div>
                        <div className='grid grid-cols-1 lg:grid-cols-2'>
                            <img
                                className='object-contain h-48 w-full'
                                alt={item.name}
                                title={item.name}
                                src={require(`../assets/img/achievements/${item.img}.png`)}
                            />
                            <div>
                                <p className='pb-2'><b>Requisito para desbloquear:</b> {item.requirement}</p>
                                <p className='pb-2'><b>Raridade:</b> {item.rarity}</p>
                                <p className='pb-2'><b>Recompensa:</b> {item.reward} pontos de experiência</p>
                            </div>
                        </div>
                        <div className='pt-5 pb-2 flex justify-end'>
                            <Button
                                className='mr-0'
                                onClick={() => setTimeout(() => {
                                    setState({ ...state, open: !open, item: null })
                                }, 300)}
                            >
                                Fechar
                            </Button>
                        </div>
                    </div>
                </Modal>
            }
        </AnimationLayout >
    )
}

export default Achievements